// the store language: labels from f5-head (window.F5T) and the locale root, so arabic pages fetch arabic sections
var F5T = window.F5T || {};
var F5R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
function f5BagLabel(n) {
  var forms = F5T.bag || {};
  var cat = 'other';
  try { cat = new Intl.PluralRules(document.documentElement.lang || 'en').select(n); } catch (e) {}
  return (forms[cat] || forms.other || '').replace('[n]', n);
}
(function () {
  'use strict';

  document.documentElement.classList.add('f5-js');

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var opener = t.closest('[data-f5-open]');
    if (opener) {
      var d = document.getElementById(opener.getAttribute('data-f5-open'));
      if (d && typeof d.showModal === 'function') {
        e.preventDefault();
        
        var from = opener.closest('dialog');
        if (from && from !== d && from.open) from.close();
        if (!d.open) d.showModal();
      }
      return;
    }

    var bag = t.closest('[data-cart-open]');
    if (bag) {
      var menu = bag.closest('dialog.f5-dlg--left');
      if (menu && menu.open) menu.close();
    }

    var closer = t.closest('[data-f5-close]');
    if (closer) {
      var host = closer.closest('dialog');
      if (host) host.close();
      return;
    }

    if (t.tagName === 'DIALOG' && t.classList.contains('f5-dlg') && t.open) t.close();
  });

  function paintCount(n) {
    var els = document.querySelectorAll('[data-f5-count]');
    for (var i = 0; i < els.length; i++) {
      var was = parseInt(els[i].textContent, 10) || 0;
      els[i].textContent = n;
      els[i].hidden = n === 0;
      if (n > was) {
        els[i].classList.remove('is-pop');
        void els[i].offsetWidth;
        els[i].classList.add('is-pop');
        if (navigator.vibrate && navigator.userActivation && navigator.userActivation.hasBeenActive) { try { navigator.vibrate(12); } catch (e) {} }
      }
    }
    var bags = document.querySelectorAll('[data-f5-bag]');
    for (var j = 0; j < bags.length; j++) {
      bags[j].setAttribute('aria-label', f5BagLabel(n));
    }
  }

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input) {
      var p = nativeFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function () {
            nativeFetch(F5R + 'cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (c) { paintCount(c.item_count); })
              .catch(function () {});
          }, function () {});
        }
      } catch (err) {}
      return p;
    };
  }

  var vids = document.querySelectorAll('video[data-f5-video]');

  (function reel() {
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      var link = v.getAttribute('data-reel-link');
      var sec = v.closest('section');
      var hit = sec && sec.querySelector('.f5-bn__hit');
      if (hit && link) hit.setAttribute('href', link);
    }
  })();
  var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection;
  var saver = !!(conn && (conn.saveData || /(^|-)2g$|^3g$/.test(conn.effectiveType || '')));

  if (vids.length && !calm && !saver && 'IntersectionObserver' in window) (function () {
    var phone = matchMedia('(max-width: 749px)');

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var v = entries[i].target;
        if (entries[i].isIntersecting) {
          if (!v.getAttribute('src')) {
            var src = phone.matches ? (v.getAttribute('data-src-m') || v.getAttribute('data-src-d')) : v.getAttribute('data-src-d');
            if (!src) continue;
            v.setAttribute('src', src);
          }
          var play = v.play();
          if (play && play.catch) play.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      }
    }, { rootMargin: '200px 0px', threshold: 0 });

    for (var k = 0; k < vids.length; k++) {
      vids[k].addEventListener('playing', function () { this.classList.add('is-on'); });
      io.observe(vids[k]);
    }
  })();

  var pdp = document.querySelector('[data-f5-pdp]');
  if (pdp) initPdp(pdp);

  function each(list, fn) {
    for (var i = 0; i < list.length; i++) fn(list[i], i);
  }

  function initPdp(root) {
    var variants = [];
    var blob = root.querySelector('[data-f5-variants]');
    if (blob) {
      try { variants = JSON.parse(blob.textContent); } catch (e) {}
    }

    var labels = {
      add: root.getAttribute('data-add') || F5T.add,
      out: root.getAttribute('data-out') || F5T.soldOut,
      none: root.getAttribute('data-none') || F5T.unavailable
    };

    var vid = root.querySelector('[data-f5-vid]');
    var sets = root.querySelectorAll('[data-f5-opt]');
    var radios = root.querySelectorAll('[data-f5-val]');
    var track = root.querySelector('[data-f5-track]');
    var dots = root.querySelectorAll('[data-f5-dot]');
    var single = window.matchMedia ? matchMedia('(max-width: 989px)') : null;

    var promoted = false;
    function promote() {
      if (promoted) return;
      promoted = true;
      each(root.querySelectorAll('img[data-srcset]'), function (img) {
        img.setAttribute('srcset', img.getAttribute('data-srcset'));
        img.removeAttribute('data-srcset');
      });
    }
    if (document.readyState === 'complete') setTimeout(promote, 200);
    else window.addEventListener('load', function () { setTimeout(promote, 200); });
    setTimeout(promote, 5000);
    if (track) {
      track.addEventListener('touchstart', promote, { passive: true });
      track.addEventListener('pointerdown', promote);
    }

    function paintDots() {
      if (!track || !dots.length) return;
      var w = track.clientWidth || 1;
      var n = Math.round(track.scrollLeft / w);
      each(dots, function (d, i) { d.classList.toggle('is-on', i === n); });
    }
    if (track && dots.length) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        promote();
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; paintDots(); });
      }, { passive: true });
    }

    function show(mediaId) {
      if (!track || !mediaId || (single && !single.matches)) return;
      each(track.querySelectorAll('[data-media]'), function (li) {
        li.style.order = li.getAttribute('data-media') === String(mediaId) ? '-1' : '';
      });
      track.scrollLeft = 0;
      promote();
      paintDots();
    }

    function picked() {
      var out = [];
      each(sets, function (set) {
        var on = set.querySelector('input:checked');
        out.push(on ? on.value : null);
      });
      return out;
    }

    function fits(vr, want) {
      for (var j = 0; j < want.length; j++) {
        if (want[j] !== null && vr.options[j] !== want[j]) return false;
      }
      return true;
    }

    function match(want) {
      for (var i = 0; i < variants.length; i++) if (fits(variants[i], want)) return variants[i];
      return null;
    }

    function canHave(pos, value) {
      var want = picked();
      want[pos] = value;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available && fits(variants[i], want)) return true;
      }
      return false;
    }

    function setAll(sel, fn) { each(root.querySelectorAll(sel), fn); }

    function onPick(first) {
      each(radios, function (r) {
        var set = r.closest('[data-f5-opt]');
        var label = r.parentNode;
        if (!set || !label) return;
        var pos = parseInt(set.getAttribute('data-f5-opt'), 10);
        label.classList.toggle('is-out', !canHave(pos, r.value));
        label.classList.toggle('is-on', r.checked);
      });

      each(sets, function (set) {
        var on = set.querySelector('input:checked');
        var out = set.querySelector('[data-f5-optval]');
        if (on && out) out.textContent = on.value;
      });

      var v = match(picked());

      if (!v) {
        setAll('[data-f5-add]', function (b) { b.disabled = true; });
        setAll('[data-f5-label]', function (l) { l.textContent = labels.none; });
        return;
      }

      if (vid) vid.value = v.id;
      each(document.querySelectorAll('[data-e5-v0]'), function (i) { i.value = v.id; });
      setAll('[data-f5-price]', function (p) { p.textContent = v.price; });
      setAll('[data-f5-was]', function (w) {
        if (v.compare) { w.textContent = v.compare; w.hidden = false; }
        else w.hidden = true;
      });
      setAll('[data-f5-add]', function (b) { b.disabled = !v.available; });
      setAll('[data-f5-label]', function (l) { l.textContent = v.available ? labels.add : labels.out; });

      if (v.tiers) {
        setAll('[data-f5-tier]', function (row, i) {
          var t = v.tiers[i];
          if (!t) return;
          var was = row.querySelector('[data-f5-tier-was]');
          var now = row.querySelector('[data-f5-tier-now]');
          if (was) was.textContent = t[0];
          if (now) now.textContent = t[1];
        });
      }

      if (!first) {
        show(v.media);
        
        if (window.history && history.replaceState) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', v.id);
            history.replaceState(history.state, '', u.toString());
          } catch (e) {}
        }
      }
    }

    each(radios, function (r) {
      r.addEventListener('change', function () { onPick(false); });
    });
    if (radios.length) onPick(true);

    var bar = root.querySelector('[data-f5-bar]');
    var main = root.querySelector('[data-f5-main]');
    if (bar && main && 'IntersectionObserver' in window) {
      // the bar only takes over once the main button has scrolled up out of view, never while it is still below
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var up = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-up', up);
        document.documentElement.classList.toggle('f5-bar-up', up);
      }, { threshold: 0 }).observe(main);
    }
  }

  function loadList(key) {
    try {
      var v = JSON.parse(window.localStorage.getItem(key) || '[]');
      return Object.prototype.toString.call(v) === '[object Array]' ? v : [];
    } catch (e) { return []; }
  }

  function saveList(key, list) {
    try { window.localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
  }

  var cardCache = {};

  function cardHtml(handle) {
    if (!cardCache[handle]) {
      cardCache[handle] = fetch(F5R + 'products/' + encodeURIComponent(handle) + '?section_id=f5-card-fragment')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    }
    return cardCache[handle];
  }

  function fillCards(list, handles, sizes, itemClass, done) {
    Promise.all(handles.map(cardHtml)).then(function (htmls) {
      var n = 0;
      each(htmls, function (h) {
        if (!h) return;
        var t = document.createElement('template');
        t.innerHTML = h;
        var art = t.content.querySelector('.f5-card');
        if (!art) return;
        if (sizes) each(art.querySelectorAll('img[sizes]'), function (img) { img.setAttribute('sizes', sizes); });
        var li = document.createElement('li');
        if (itemClass) li.className = itemClass;
        li.appendChild(art);
        list.appendChild(li);
        n++;
      });
      paintHearts();
      done(n);
    });
  }

  function paintHearts() {
    var list = loadList('f5-wish');
    each(document.querySelectorAll('[data-f5-wish]'), function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-f5-wish')) > -1 ? 'true' : 'false');
    });
    each(document.querySelectorAll('[data-f5-wish-count]'), function (c) {
      c.textContent = list.length;
      c.hidden = list.length === 0;
    });
  }

  var wl = document.querySelector('[data-f5-wishlist]');

  function paintWishlist() {
    if (!wl) return;
    var n = wl.querySelectorAll('[data-f5-list] > li').length;
    var count = wl.querySelector('[data-f5-wl-count]');
    var empty = wl.querySelector('[data-f5-wl-empty]');
    if (count) count.textContent = n ? n : '';
    if (empty) empty.hidden = n > 0;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var b = t && t.closest ? t.closest('[data-f5-wish]') : null;
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-f5-wish');
    var list = loadList('f5-wish');
    var i = list.indexOf(h);
    if (i > -1) list.splice(i, 1);
    else list.unshift(h);
    saveList('f5-wish', list.slice(0, 60));
    paintHearts();
    
    if (i > -1 && wl && wl.contains(b)) {
      var li = b.closest('li');
      if (li) li.parentNode.removeChild(li);
      paintWishlist();
    }
  });

  paintHearts();

  if (wl) {
    var saved = loadList('f5-wish');
    var grid = wl.querySelector('[data-f5-list]');
    if (saved.length && grid) {
      fillCards(grid, saved, null, '', paintWishlist);
    } else {
      paintWishlist();
    }
  }

  var here = pdp ? pdp.getAttribute('data-handle') : '';
  var rv = document.querySelector('[data-f5-recent]');

  if (rv) {
    var skip = rv.getAttribute('data-f5-recent') || here;
    var max = parseInt(rv.getAttribute('data-max'), 10) || 8;
    var seen = [];
    each(loadList('f5-rv'), function (h) { if (h !== skip && seen.length < max) seen.push(h); });
    var track = rv.querySelector('[data-f5-list]');
    if (seen.length && track) {
      fillCards(track, seen, null, 'f5-rail__item', function (n) {
        if (!n) return;
        rv.hidden = false;
      });
    }
  }

  if (here) {
    var past = [here];
    each(loadList('f5-rv'), function (h) { if (h !== here && past.length < 16) past.push(h); });
    saveList('f5-rv', past);
  }

  var sd = document.getElementById('F5Search');
  var sq = sd ? sd.querySelector('[data-f5-q]') : null;

  if (sd && sq) {
    var res = sd.querySelector('[data-f5-results]');
    var links = sd.querySelector('[data-f5-sd-links]');
    var base = sd.getAttribute('data-f5-suggest') || '/search/suggest';
    var timer = null;
    var lastTerm = '';
    var ctrl = null;

    sq.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var term = sq.value.replace(/^\s+|\s+$/g, '');
        if (term === lastTerm) return;
        lastTerm = term;
        if (term.length < 2) {
          res.innerHTML = '';
          if (links) links.hidden = false;
          return;
        }
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        fetch(base + '?q=' + encodeURIComponent(term) + '&resources%5Btype%5D=product&resources%5Blimit%5D=6&section_id=f5-predictive', ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (h) {
            if (term !== lastTerm) return;
            var t = document.createElement('template');
            t.innerHTML = h;
            var inner = t.content.querySelector('.shopify-section') || t.content;
            res.innerHTML = '';
            while (inner.firstChild) res.appendChild(inner.firstChild);
            if (links) links.hidden = res.children.length > 0;
            paintHearts();
          })
          .catch(function () {});
      }, 220);
    });
  }

  each(document.querySelectorAll('[data-f5-reels]'), initReels);

  function initReels(root) {
    var track = root.querySelector('[data-f5-reels-track]');
    if (!track) return;
    var cards = track.querySelectorAll('[data-f5-reel]');
    if (!cards.length) return;
    
    var sets = 1;
    var per = cards.length;
    var loop = track.hasAttribute('data-loop') && per > 1;
    var dlg = root.querySelector('[data-f5-rp]');
    var list = dlg ? dlg.querySelector('[data-f5-rp-list]') : null;
    var tpl = dlg ? dlg.querySelector('[data-f5-rp-tpl]') : null;
    var slides = dlg ? dlg.querySelectorAll('[data-f5-rp-slide]') : [];
    var pv = dlg ? dlg.querySelector('[data-f5-rp-vid]') : null;
    var home = pv ? pv.parentNode : null;
    var bar = dlg ? dlg.querySelector('[data-f5-rp-progress]') : null;
    var muteBtn = dlg ? dlg.querySelector('[data-f5-rp-mute]') : null;
    var quiet = calm || saver;
    var active = 0;
    var seen = false;
    var current = -1;
    each(cards, function (c, k) { if (c.classList.contains('is-active')) active = k; });

    function preview(i, on) {
      var v = cards[i] ? cards[i].querySelector('video') : null;
      if (!v) return;
      if (!on) { if (!v.paused) v.pause(); return; }
      if (quiet || !seen || (dlg && dlg.open)) return;
      if (!v.getAttribute('src')) {
        var src = v.getAttribute('data-src');
        if (!src) return;
        v.setAttribute('src', src);
      }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    function setActive(i) {
      if (i === active) return;
      preview(active, false);
      cards[active].classList.remove('is-active');
      active = i;
      cards[active].classList.add('is-active');
      preview(active, true);
    }

    function onPlaying() { this.classList.add('is-on'); }
    each(cards, function (c) {
      var v = c.querySelector('video');
      if (v) v.addEventListener('playing', onPlaying);
    });

    function copyCard(c) {
      var n = c.cloneNode(true);
      n.classList.remove('is-active');
      n.setAttribute('aria-hidden', 'true');
      n.removeAttribute('data-shopify-editor-block');
      each(n.querySelectorAll('a, button, input, select, textarea'), function (el) { el.setAttribute('tabindex', '-1'); });
      each(n.querySelectorAll('video'), function (v) {
        v.removeAttribute('src');
        v.classList.remove('is-on');
        v.addEventListener('playing', onPlaying);
      });
      return n;
    }

    function buildLoop() {
      if (!loop || sets === 3) return;
      var real = Array.prototype.slice.call(cards);
      var before = real[active].offsetLeft;
      var head = document.createDocumentFragment();
      var tail = document.createDocumentFragment();
      each(real, function (c) { head.appendChild(copyCard(c)); tail.appendChild(copyCard(c)); });
      track.classList.add('is-jumping');
      track.insertBefore(head, track.firstChild);
      track.appendChild(tail);
      cards = track.querySelectorAll('[data-f5-reel]');
      sets = 3;
      active += per;
      track.scrollLeft += cards[active].offsetLeft - before;
      void track.offsetWidth;
      track.classList.remove('is-jumping');
    }

    var frame = 0;
    function nearest() {
      frame = 0;
      var r = track.getBoundingClientRect();
      var mid = r.left + r.width / 2;
      var best = active;
      var gap = Infinity;
      each(cards, function (c, k) {
        var b = c.getBoundingClientRect();
        var d = Math.abs(b.left + b.width / 2 - mid);
        if (d < gap) { gap = d; best = k; }
      });
      setActive(best);
    }
    track.addEventListener('scroll', function () {
      if (!frame) frame = window.requestAnimationFrame ? requestAnimationFrame(nearest) : setTimeout(nearest, 50);
    }, { passive: true });

    function go(i, instant) {
      i = Math.max(0, Math.min(cards.length - 1, i));
      var c = cards[i];
      var left = c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2;
      if (instant || calm || !track.scrollTo) track.scrollLeft = left;
      else track.scrollTo({ left: left, behavior: 'smooth' });
      setActive(i);
    }

    function settle() {
      if (sets < 3) return;
      var shift = active < per ? per : active >= per * 2 ? -per : 0;
      if (!shift) return;
      var from = cards[active];
      var to = cards[active + shift];
      var oldV = from.querySelector('video');
      var t = oldV && !oldV.paused ? oldV.currentTime : 0;
      track.classList.add('is-jumping');
      track.scrollLeft += to.offsetLeft - from.offsetLeft;
      setActive(active + shift);
      var newV = to.querySelector('video');
      if (newV && t) {
        var seek = function () {
          newV.removeEventListener('loadedmetadata', seek);
          try { newV.currentTime = t; } catch (err) {}
        };
        if (newV.readyState >= 1) seek(); else newV.addEventListener('loadedmetadata', seek);
      }
      void track.offsetWidth;
      track.classList.remove('is-jumping');
    }

    var rest = 0;
    track.addEventListener('scroll', function () {
      clearTimeout(rest);
      rest = setTimeout(settle, 160);
    }, { passive: true });
    if ('onscrollend' in window) track.addEventListener('scrollend', function () { clearTimeout(rest); settle(); });

    var start = 0;
    if (track.clientWidth >= cards[0].offsetWidth * 3) start = Math.floor((per - 1) / 2);
    track.classList.add('is-jumping');
    go(start, true);
    void track.offsetWidth;
    track.classList.remove('is-jumping');

    var sizing = 0;
    window.addEventListener('resize', function () {
      clearTimeout(sizing);
      sizing = setTimeout(function () { go(active, true); }, 150);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        seen = es[es.length - 1].isIntersecting;
        preview(active, seen);
      }, { threshold: 0.3 }).observe(track);
    }

    if (loop) {
      each(['pointerdown', 'touchstart', 'wheel', 'focusin'], function (type) {
        track.addEventListener(type, buildLoop, { once: true, passive: true });
      });
      if ('IntersectionObserver' in window) {
        var near = new IntersectionObserver(function (es) {
          if (!es[es.length - 1].isIntersecting) return;
          near.disconnect();
          buildLoop();
        }, { rootMargin: '0px 0px 600px 0px' });
        near.observe(track);
      }
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      var opener = t.closest('[data-f5-reel-open]');
      if (opener) { open(+opener.getAttribute('data-f5-reel-open')); return; }
      var stepper = t.closest('[data-f5-reels-step]');
      if (stepper) { buildLoop(); go(active + (+stepper.getAttribute('data-f5-reels-step'))); }
    });

    if (!dlg || !pv || !list || typeof dlg.showModal !== 'function') {
      open = function (i) {
        var b = track.querySelector('[data-f5-reel-open="' + i + '"][data-ig]');
        if (b) window.open(b.getAttribute('data-ig'), '_blank', 'noopener');
      };
      return;
    }

    function buildSlides() {
      if (!tpl || slides.length) return;
      list.appendChild(tpl.content);
      slides = list.querySelectorAll('[data-f5-rp-slide]');
      paintHearts();
    }

    function paintMute() {
      if (!muteBtn) return;
      muteBtn.setAttribute('aria-pressed', pv.muted ? 'true' : 'false');
      muteBtn.setAttribute('aria-label', pv.muted ? F5T.soundOn : F5T.mute);
    }

    function play() {
      var p = pv.play();
      if (p && p.catch) p.catch(function () {
        pv.muted = true;
        paintMute();
        var q = pv.play();
        if (q && q.catch) q.catch(function () {});
      });
    }

    function show(i) {
      if (i === current || !slides[i]) return;
      current = i;
      var slide = slides[i];
      each(slides, function (s, k) {
        s.classList.toggle('is-active', k === i);
        s.classList.remove('is-paused');
      });
      pv.classList.remove('is-on');
      var frame = slide.querySelector('.f5-rp__frame') || slide;
      frame.insertBefore(pv, frame.querySelector('.f5-grain') || frame.querySelector('.f5-rp__paused'));
      pv.src = slide.getAttribute('data-src');
      if (bar) bar.style.transform = 'scaleX(0)';
      play();
    }

    function open(i) {
      buildSlides();
      each(cards, function (c, k) { preview(k, false); });
      dlg.showModal();
      pv.muted = false;
      paintMute();
      current = -1;
      list.scrollTop = slides[i] ? slides[i].offsetTop : 0;
      show(i);
    }

    function share(btn) {
      var url = btn.getAttribute('data-url');
      if (navigator.share) {
        navigator.share({ title: btn.getAttribute('data-title') || '', url: url }).catch(function () {});
        return;
      }
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(url).then(function () {
        var label = btn.parentNode.querySelector('[data-f5-rp-share-label]');
        var copied = dlg.getAttribute('data-copied');
        if (!label || !copied) return;
        var was = label.textContent;
        label.textContent = copied;
        setTimeout(function () { label.textContent = was; }, 1600);
      }).catch(function () {});
    }

    function step(d) {
      var i = Math.max(0, Math.min(slides.length - 1, current + d));
      if (!list.scrollTo || calm) list.scrollTop = slides[i].offsetTop;
      else list.scrollTo({ top: slides[i].offsetTop, behavior: 'smooth' });
    }

    var pframe = 0;
    list.addEventListener('scroll', function () {
      if (pframe) return;
      var settle = function () {
        pframe = 0;
        var i = Math.round(list.scrollTop / (list.clientHeight || 1));
        if (i !== current) show(i);
      };
      pframe = window.requestAnimationFrame ? requestAnimationFrame(settle) : setTimeout(settle, 50);
    }, { passive: true });

    pv.addEventListener('playing', function () { pv.classList.add('is-on'); });
    pv.addEventListener('timeupdate', function () {
      if (bar && pv.duration) bar.style.transform = 'scaleX(' + (pv.currentTime / pv.duration) + ')';
    });

    dlg.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      if (t.closest('[data-f5-rp-mute]')) {
        pv.muted = !pv.muted;
        paintMute();
        if (pv.paused) play();
        return;
      }
      var stepper = t.closest('[data-f5-rp-step]');
      if (stepper) { step(+stepper.getAttribute('data-f5-rp-step')); return; }
      var sharer = t.closest('[data-f5-rp-share]');
      if (sharer) { share(sharer); return; }
      if (t.closest('a, button, form, input')) return;
      var slide = t.closest('[data-f5-rp-slide]');
      if (!slide || !slide.classList.contains('is-active')) return;
      if (pv.paused) { play(); slide.classList.remove('is-paused'); }
      else { pv.pause(); slide.classList.add('is-paused'); }
    });

    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'PageDown') { e.preventDefault(); step(1); }
      else if (e.key === 'ArrowUp' || e.key === 'PageUp') { e.preventDefault(); step(-1); }
    });

    dlg.addEventListener('submit', function () {
      pv.pause();
      if (slides[current]) slides[current].classList.add('is-paused');
    });

    dlg.addEventListener('close', function () {
      pv.pause();
      pv.removeAttribute('src');
      pv.load();
      pv.classList.remove('is-on');
      home.appendChild(pv);
      current = -1;
      preview(active, true);
    });
  }

  var ftWrap = document.querySelector('.f5-ftwrap');
  if (ftWrap) {
    var fitFrame = 0;
    var fitFooter = function () {
      fitFrame = 0;
      var vh = Math.min(window.innerHeight || 0, document.documentElement.clientHeight || 0);
      var fh = ftWrap.offsetHeight;
      var mainBox = document.getElementById('MainContent');
      var on = vh > 0 && fh > 0 && fh <= vh - 64 && (!mainBox || mainBox.offsetHeight > vh);
      document.documentElement.classList.toggle('f5-reveal', on);
    };
    var askFit = function () {
      if (!fitFrame) fitFrame = window.requestAnimationFrame ? requestAnimationFrame(fitFooter) : setTimeout(fitFooter, 16);
    };
    fitFooter();
    window.addEventListener('resize', askFit);

    var endMark = document.querySelector('.f5-end');
    if (endMark && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        var near = e.isIntersecting || e.boundingClientRect.top < 0;
        document.documentElement.classList.toggle('f5-near-end', near);
      }, { rootMargin: '0px 0px 50% 0px' }).observe(endMark);
    }

    var mainEl = document.getElementById('MainContent');
    var toFooter = function () {
      if (!mainEl || !document.documentElement.classList.contains('f5-reveal')) return;
      if (mainEl.getBoundingClientRect().bottom > ftWrap.getBoundingClientRect().top + 1) {
        window.scrollTo(0, document.documentElement.scrollHeight);
      }
    };
    var hashInFooter = function () {
      try { return !!(location.hash && ftWrap.querySelector(location.hash)); } catch (err) { return false; }
    };
    // how much of the footer is showing (0 to 1), so the big mark can rise into place
    var ftEl = ftWrap.querySelector('[data-e5-ft]');
    var calmFt = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (ftEl && !calmFt) {
      var ftTick = false;
      var ftPaint = function () {
        ftTick = false;
        var vh = window.innerHeight;
        var top = ftEl.getBoundingClientRect().top;
        var cover = mainEl ? Math.max(0, mainEl.getBoundingClientRect().bottom - top) : 0;
        var shown = Math.min(ftEl.offsetHeight, Math.max(0, vh - top - cover));
        ftEl.style.setProperty('--ft-p', ftEl.offsetHeight ? (shown / ftEl.offsetHeight).toFixed(3) : 1);
      };
      window.addEventListener('scroll', function () { if (!ftTick) { ftTick = true; requestAnimationFrame(ftPaint); } }, { passive: true });
      window.addEventListener('resize', ftPaint);
      ftPaint();
    }

    ftWrap.addEventListener('focusin', toFooter);
    window.addEventListener('hashchange', function () { if (hashInFooter()) toFooter(); });
    window.addEventListener('load', function () {
      fitFooter();
      if (hashInFooter()) toFooter();
    });
  }
})();

(function () {
  var fits = document.querySelectorAll('[data-e5-fit]');
  function fit() {
    for (var i = 0; i < fits.length; i++) {
      var el = fits[i];
      var box = el.parentNode.clientWidth;
      if (!box) continue;
      el.style.fontSize = '100px';
      var w = el.scrollWidth;
      if (!w) continue;
      var size = Math.floor(100 * box / w * 0.98);
      // a ceiling in vw (phone, desktop) so short words do not blow up: every banner title ends up about the same size
      var cap = (el.getAttribute('data-e5-fit-max') || '15,8').split(',');
      size = Math.min(size, window.innerWidth * parseFloat(window.innerWidth < 750 ? cap[0] : (cap[1] || cap[0])) / 100);
      el.style.fontSize = Math.max(32, Math.min(Math.floor(size), 260)) + 'px';
    }
  }
  if (fits.length) {
    fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 120); });
  }

  var grid = document.querySelector('[data-e5-grid]');
  var dens = document.querySelectorAll('[data-e5-dens]');
  function setDens(n) {
    if (!grid) return;
    grid.setAttribute('data-dens', n);
    for (var j = 0; j < dens.length; j++) {
      dens[j].setAttribute('aria-pressed', dens[j].getAttribute('data-e5-dens') === n ? 'true' : 'false');
    }
    try { localStorage.setItem('e5-dens', n); } catch (e) {}
  }
  for (var k = 0; k < dens.length; k++) {
    dens[k].addEventListener('click', function () { setDens(this.getAttribute('data-e5-dens')); });
  }
  if (grid) {
    var saved = null;
    try { saved = localStorage.getItem('e5-dens'); } catch (e) {}
    setDens(saved || (window.innerWidth < 990 ? '2' : '4'));
  }

  var imgs = document.querySelectorAll('.e5-cmp__img, .e5-split__img');
  for (var m = 0; m < imgs.length; m++) {
    var im = imgs[m];
    if (im.getAttribute('fetchpriority') === 'high') continue;
    if (im.complete && im.naturalWidth) continue;
    im.classList.add('e5-in');
    im.addEventListener('load', function () { this.classList.add('is-in'); });
    im.addEventListener('error', function () { this.classList.add('is-in'); });
  }
  window.addEventListener('load', function () {
    var left = document.querySelectorAll('.e5-in:not(.is-in)');
    setTimeout(function () { for (var n = 0; n < left.length; n++) left[n].classList.add('is-in'); }, 1500);
  });
})();

(function () {
  var qs = document.querySelectorAll('[data-e5-qty]');
  for (var i = 0; i < qs.length; i++) (function (box) {
    var input = box.querySelector('input');
    var less = box.querySelector('[data-e5-q="-1"]');
    function set(n) {
      n = Math.max(1, Math.min(20, parseInt(n, 10) || 1));
      input.value = n;
      less.disabled = n <= 1;
    }
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-e5-q]');
      if (b) set(parseInt(input.value, 10) + parseInt(b.getAttribute('data-e5-q'), 10));
    });
    input.addEventListener('change', function () { set(input.value); });
    set(input.value);
  })(qs[i]);
})();

(function () {
  var phone = window.matchMedia('(max-width: 989px)');
  var root = document.documentElement;
  var hd = document.querySelector('[data-e5-hd]');

  if (hd) {
    var last = window.scrollY;
    var ticking = false;
    function onScroll() {
      ticking = false;
      var y = window.scrollY;
      if (!phone.matches || document.querySelector('dialog[open]')) { last = y; return; }
      if (y > last + 6 && y > 140) hd.classList.add('is-hid');
      else if (y < last - 6 || y < 140) hd.classList.remove('is-hid');
      root.classList.toggle('e5-hd-shown', !hd.classList.contains('is-hid') && y > 140);
      last = y;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });
  }

  var back = document.querySelector('[data-e5-back]');
  if (back) {
    back.addEventListener('click', function (e) {
      var ref = document.referrer;
      if (ref && ref.indexOf(location.origin) === 0 && window.history.length > 1) {
        e.preventDefault();
        window.history.back();
      }
    });
  }

  var sheetMq = window.matchMedia('(max-width: 749px)');

  function scroller(el, stop) {
    while (el && el !== stop) {
      if (el.scrollHeight > el.clientHeight + 1) {
        var oy = window.getComputedStyle(el).overflowY;
        if (oy === 'auto' || oy === 'scroll') return el;
      }
      el = el.parentElement;
    }
    return stop.scrollHeight > stop.clientHeight + 1 ? stop : null;
  }

  function dismiss(d) {
    d.classList.remove('is-drag');
    d.style.transition = 'transform 0.28s cubic-bezier(0.32, 0.72, 0, 1)';
    d.style.transform = 'translateY(100%)';
    setTimeout(function () {
      if (d.open) d.close();
      d.style.transition = '';
      d.style.transform = '';
    }, 280);
  }

  var drag = null;

  document.addEventListener('touchstart', function (e) {
    if (!sheetMq.matches || e.touches.length !== 1) return;
    var d = e.target.closest && e.target.closest('dialog.f5-dlg[open]');
    // the menu is a full page on phones, closed with its x, so it does not take the swipe down
    if (!d || d.classList.contains('f5-dlg--reel') || d.id === 'F5Menu') return;
    var tag = e.target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
    if (e.target.closest('.pd-row, .f5-bag__up, [data-f5-track], .f5-rail__track')) return;
    var sc = scroller(e.target, d);
    drag = {
      d: d,
      y0: e.touches[0].clientY,
      x0: e.touches[0].clientX,
      t0: Date.now(),
      dy: 0,
      ok: !sc || sc.scrollTop <= 0,
      on: false
    };
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!drag || !drag.ok) return;
    var dy = e.touches[0].clientY - drag.y0;
    var dx = e.touches[0].clientX - drag.x0;
    if (!drag.on) {
      if (dy < 6 || Math.abs(dx) > dy) { if (dy < -2 || Math.abs(dx) > 8) drag = null; return; }
      drag.on = true;
      drag.d.classList.add('is-drag');
    }
    drag.dy = dy;
    e.preventDefault();
    drag.d.style.transform = 'translateY(' + Math.max(0, dy) + 'px)';
  }, { passive: false });

  function end() {
    if (!drag) return;
    var g = drag;
    drag = null;
    if (!g.on) return;
    var v = g.dy / Math.max(1, Date.now() - g.t0);
    if (g.dy > 110 || v > 0.6) { dismiss(g.d); return; }
    g.d.classList.remove('is-drag');
    g.d.style.transition = 'transform 0.3s cubic-bezier(0.32, 0.72, 0, 1)';
    g.d.style.transform = '';
    setTimeout(function () { g.d.style.transition = ''; }, 300);
  }
  document.addEventListener('touchend', end);
  document.addEventListener('touchcancel', end);
})();


// the white header logo needs colour under it: the hero, or the lagoon masthead on pages without one.
// e5-on-hero while it sits on a hero, e5-off-mast once the page has scrolled out from under it
(function () {
  var hd = document.querySelector('[data-e5-hd]');
  var top = hd && hd.closest('.f5-top');
  if (!hd || !top) return;
  var onHero = top.classList.contains('is-over');
  var hero = onHero && document.querySelector('#MainContent .f5-bn, #MainContent .e5-cmp, #MainContent .e5-cover');
  var masts = hero ? [hero] : [].slice.call(document.querySelectorAll('.f5-top, #MainContent > .shopify-section:first-child > * > .f5-coll__head:first-child, .f5-read__top'));
  var logo = hd.querySelector('.f5-hd__logo');
  var tick = false;
  function set() {
    tick = false;
    var b = 0;
    masts.forEach(function (m) { b = Math.max(b, m.getBoundingClientRect().bottom); });
    var l = logo ? logo.getBoundingClientRect().bottom : 80;
    var on = b > l + 4;
    if (hero) hd.classList.toggle('e5-on-hero', on);
    hd.classList.toggle('e5-off-mast', !on);
  }
  window.addEventListener('scroll', function () {
    if (!tick) { tick = true; requestAnimationFrame(set); }
  }, { passive: true });
  window.addEventListener('resize', set);
  set();
})();

(function () {
  var dlg = document.getElementById('E5Story');
  if (!dlg || typeof dlg.showModal !== 'function') return;

  var vid = dlg.querySelector('.e5-sv__vid');
  var bars = dlg.querySelector('[data-sv-bars]');
  var nameEl = dlg.querySelector('[data-sv-name]');
  var av = dlg.querySelector('[data-sv-av]');
  var card = dlg.querySelector('[data-sv-card]');
  var cta = dlg.querySelector('[data-sv-cta]');
  var ctaImg = dlg.querySelector('[data-sv-cta-img]');
  var ctaT = dlg.querySelector('[data-sv-cta-t]');
  var ctaP = dlg.querySelector('[data-sv-cta-p]');
  var ctaWas = dlg.querySelector('[data-sv-cta-was]');
  var addForm = dlg.querySelector('[data-sv-add]');
  var addVid = dlg.querySelector('[data-sv-vid]');
  var snd = dlg.querySelector('[data-sv-sound]');
  var tap = dlg.querySelector('[data-sv-tap]');
  var shopLabel = dlg.getAttribute('data-shop') || F5T.shopNow;
  var rtl = function () { return document.documentElement.dir === 'rtl'; };

  var list = [], s = 0, i = 0, raf = 0, muted = true, holdT = 0, held = false, x0 = 0, y0 = 0, down = false;

  var KEY = 'e5-st-seen';
  var seen = {};
  try { seen = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) {}
  function paintSeen() {
    var btns = document.querySelectorAll('[data-e5-story]');
    for (var b = 0; b < btns.length; b++) btns[b].classList.toggle('is-seen', !!seen[btns[b].getAttribute('data-e5-story')]);
  }
  function markSeen(id) {
    seen[id] = 1;
    try { localStorage.setItem(KEY, JSON.stringify(seen)); } catch (e) {}
  }
  paintSeen();

  function open(l, k) {
    list = l; s = k; i = 0;
    document.documentElement.classList.add('e5-sv-open');
    if (!dlg.open) dlg.showModal();
    show();
  }

  function itemFrom(e) {
    return {
      src: e.getAttribute('data-src'),
      poster: e.getAttribute('data-poster'),
      title: e.getAttribute('data-p-title'),
      url: e.getAttribute('data-p-url'),
      price: e.getAttribute('data-p-price'),
      img: e.getAttribute('data-p-img'),
      was: e.getAttribute('data-p-was'),
      vid: e.getAttribute('data-p-vid'),
      ok: !!e.getAttribute('data-p-ok')
    };
  }
  function storyFrom(tp) {
    var box = tp.content || tp;
    var its = box.querySelectorAll('i[data-src]');
    var items = [];
    for (var k = 0; k < its.length; k++) items.push(itemFrom(its[k]));
    return { id: tp.getAttribute('data-e5-st'), name: tp.getAttribute('data-name'), cover: tp.getAttribute('data-cover'), link: tp.getAttribute('data-link'), items: items };
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-e5-story]');
    if (!b) return;
    var row = b.closest('[data-e5-stories]');
    var group = row ? row.querySelectorAll('template[data-e5-st]') : [];
    var l = [], at = 0;
    if (!group.length) group = b.parentNode.querySelectorAll('template[data-e5-st]');
    for (var t = 0; t < group.length; t++) {
      var st = storyFrom(group[t]);
      if (!st.items.length) continue;
      if (st.id === b.getAttribute('data-e5-story')) at = l.length;
      l.push(st);
    }
    if (!l.length) return;
    e.preventDefault();
    e.stopPropagation();
    open(l, at);
  }, true);

  function stop() { cancelAnimationFrame(raf); vid.pause(); }
  function close() { stop(); if (dlg.open) dlg.close(); }
  dlg.addEventListener('close', function () {
    stop();
    vid.removeAttribute('src');
    try { vid.load(); } catch (e) {}
    document.documentElement.classList.remove('e5-sv-open');
    paintSeen();
  });

  function show() {
    var st = list[s];
    var it = st.items[i];
    markSeen(st.id);
    bars.innerHTML = '';
    for (var k = 0; k < st.items.length; k++) {
      var bar = document.createElement('span');
      bar.className = 'e5-sv__bar';
      var fill = document.createElement('i');
      fill.style.width = k < i ? '100%' : '0';
      bar.appendChild(fill);
      bars.appendChild(bar);
    }
    nameEl.textContent = st.name;
    if (st.cover) av.src = st.cover;
    if (it.url || st.link) {
      cta.href = it.url || st.link;
      ctaT.textContent = it.title || shopLabel;
      ctaP.textContent = it.price || '';
      ctaWas.textContent = it.was || '';
      ctaWas.hidden = !it.was;
      if (it.img) { ctaImg.src = it.img; ctaImg.hidden = false; } else { ctaImg.hidden = true; }
      addVid.value = it.vid || '';
      addForm.hidden = !(it.vid && it.ok);
      card.hidden = false;
    } else {
      card.hidden = true;
    }
    cancelAnimationFrame(raf);
    vid.poster = it.poster || '';
    vid.muted = muted;
    vid.src = it.src;
    var p = vid.play();
    if (p && p.catch) p.catch(function () {});
    raf = requestAnimationFrame(tick);
    var nx = st.items[i + 1] || (list[s + 1] && list[s + 1].items[0]);
    if (nx && nx.poster) { var pre = new Image(); pre.src = nx.poster; }
  }

  function tick() {
    var f = bars.children[i] && bars.children[i].firstChild;
    if (f && vid.duration) f.style.width = Math.min(100, vid.currentTime / vid.duration * 100) + '%';
    raf = requestAnimationFrame(tick);
  }

  function next() { if (i < list[s].items.length - 1) { i++; show(); } else nextStory(); }
  function prev() {
    if (i > 0) { i--; show(); }
    else if (s > 0) { s--; i = 0; show(); }
    else vid.currentTime = 0;
  }
  function nextStory() { if (s < list.length - 1) { s++; i = 0; show(); } else close(); }
  function prevStory() { if (s > 0) { s--; i = 0; show(); } }

  vid.addEventListener('ended', next);

  function pause() { held = true; vid.pause(); dlg.classList.add('is-held'); }
  function resume() {
    dlg.classList.remove('is-held');
    if (held) { held = false; var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
  }

  addForm.addEventListener('click', function (e) {
    if (!e.target.closest('button')) return;
    pause();
    var cart = document.getElementById('EfCart');
    if (cart) cart.addEventListener('close', function back() {
      cart.removeEventListener('close', back);
      if (dlg.open) resume();
    });
  });

  tap.addEventListener('pointerdown', function (e) {
    down = true; held = false; x0 = e.clientX; y0 = e.clientY;
    clearTimeout(holdT);
    holdT = setTimeout(pause, 220);
  });
  tap.addEventListener('pointerup', function (e) {
    if (!down) return;
    down = false;
    clearTimeout(holdT);
    var dx = e.clientX - x0, dy = e.clientY - y0;
    if (held) { resume(); return; }
    if (dy > 90 && Math.abs(dy) > Math.abs(dx)) { close(); return; }
    if (Math.abs(dx) > 60) { if ((dx < 0) !== rtl()) nextStory(); else prevStory(); return; }
    var r = tap.getBoundingClientRect();
    var left = (e.clientX - r.left) < r.width / 3;
    if (rtl()) left = (e.clientX - r.left) > r.width * 2 / 3;
    if (left) prev(); else next();
  });
  tap.addEventListener('pointercancel', function () { down = false; clearTimeout(holdT); resume(); });

  snd.addEventListener('click', function () {
    muted = !muted;
    vid.muted = muted;
    snd.setAttribute('aria-pressed', muted ? 'false' : 'true');
  });
  dlg.querySelector('[data-sv-close]').addEventListener('click', close);
  dlg.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') next();
    else if (e.key === 'ArrowLeft') prev();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden && dlg.open) vid.pause();
    else if (dlg.open && !held) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
  });
})();

(function () {
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.hasAttribute && f.hasAttribute('data-e5-add')) {
      var b = f.querySelector('.e5-add');
      if (b) b.classList.add('is-busy');
    }
  }, true);
  document.addEventListener('ef:cart:added', function (e) {
    var b = e.target.querySelector && e.target.querySelector('.e5-add');
    if (!b) return;
    b.classList.remove('is-busy');
    b.classList.add('is-done');
    clearTimeout(b._t);
    b._t = setTimeout(function () { b.classList.remove('is-done'); }, 1800);
  });

  var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection;
  if (calm || (conn && conn.saveData) || !('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (es) {
    for (var i = 0; i < es.length; i++) {
      var v = es[i].target.querySelector('.f5-card__vid');
      if (!v) continue;
      if (es[i].isIntersecting) {
        if (!v.getAttribute('src')) v.setAttribute('src', v.getAttribute('data-card-src'));
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    }
  }, { threshold: 0.4 });

  function scan() {
    var vs = document.querySelectorAll('.f5-card__vid[data-card-src]');
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      if (v._e5) continue;
      v._e5 = 1;
      v.addEventListener('playing', function () { this.classList.add('is-on'); });
      io.observe(v.closest('.f5-card__media'));
    }
  }

  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('visibilitychange', function () {
    var vs = document.querySelectorAll('.f5-card__vid.is-on');
    for (var i = 0; i < vs.length; i++) {
      if (document.hidden) vs[i].pause();
      else { var p = vs[i].play(); if (p && p.catch) p.catch(function () {}); }
    }
  });
})();

(function () {
  var vids = document.querySelectorAll('video[data-e5-auto]');
  if (!vids.length) return;
  var phone = window.matchMedia('(max-width: 749px)').matches;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection;
  var still = calm || !!(conn && conn.saveData);
  // two watchers: one starts downloading about a screen ahead so the clip is ready when it arrives,
  // the other plays only while the clip is actually on screen
  var near = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    for (var i = 0; i < es.length; i++) {
      if (!es[i].isIntersecting) continue;
      var v = es[i].target;
      if (!v.getAttribute('src')) { v.preload = 'auto'; v.setAttribute('src', v._src); }
      near.unobserve(v);
    }
  }, { rootMargin: '120% 0px' }) : null;
  var io = near ? new IntersectionObserver(function (es) {
    for (var i = 0; i < es.length; i++) {
      var v = es[i].target;
      if (es[i].isIntersecting) {
        if (!v.getAttribute('src')) v.setAttribute('src', v._src);
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    }
  }) : null;
  for (var i = 0; i < vids.length; i++) {
    var v = vids[i];
    var src = phone ? (v.getAttribute('data-src-m') || v.getAttribute('data-src-d')) : (v.getAttribute('data-src-d') || '');
    if (!src) continue;
    var poster = phone ? (v.getAttribute('data-poster-m') || v.getAttribute('data-poster-d')) : v.getAttribute('data-poster-d');
    if (poster) v.setAttribute('poster', poster);
    v._src = src;
    v.classList.add('is-ready');
    if (!still && io) { near.observe(v); io.observe(v); }
  }
})();

(function () {
  var root = document.querySelector('[data-e5-slides]');
  if (!root) return;
  var sec = root.closest('.f5-bn');
  var items = root.querySelectorAll('.e5-sl__i');
  var dots = sec.querySelectorAll('.e5-sl__dot');
  var hit = sec.querySelector('.f5-bn__hit');
  if (items.length < 2) return;
  var at = 0;

  function go(n) {
    n = (n + items.length) % items.length;
    if (n === at) return;
    items[at].classList.remove('is-on');
    dots[at].classList.remove('is-on');
    dots[at].removeAttribute('aria-current');
    at = n;
    var img = items[at].querySelector('img');
    if (img && img.loading === 'lazy') img.loading = 'eager';
    items[at].classList.add('is-on');
    void dots[at].offsetWidth;
    dots[at].classList.add('is-on');
    dots[at].setAttribute('aria-current', 'true');
    var link = items[at].getAttribute('data-link');
    if (hit && link) hit.setAttribute('href', link);
  }

  for (var i = 0; i < dots.length; i++) {
    dots[i].addEventListener('click', go.bind(null, i));
    dots[i].addEventListener('animationend', function () {
      if (this.classList.contains('is-on')) go(at + 1);
    });
  }
})();

(function () {
  var rows = document.querySelectorAll('[data-e5-rcp]');
  for (var i = 0; i < rows.length; i++) (function (row) {
    var bar = row.parentNode.querySelector('[data-e5-rcp-bar]');
    if (!bar) return;
    var track = bar.parentNode;
    var tick = false;
    function set() {
      tick = false;
      var max = row.scrollWidth - row.clientWidth;
      var share = row.scrollWidth ? row.clientWidth / row.scrollWidth : 1;
      track.style.visibility = max > 2 ? '' : 'hidden';
      var w = track.clientWidth * share;
      var dir = getComputedStyle(row).direction === 'rtl' ? -1 : 1;
      var at = max > 0 ? Math.abs(row.scrollLeft) / max : 0;
      track.style.setProperty('--rcp-w', w + 'px');
      track.style.setProperty('--rcp-x', dir * at * (track.clientWidth - w) + 'px');
    }
    row.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(set); } }, { passive: true });
    window.addEventListener('resize', set);
    set();
  })(rows[i]);
})();

// whatsapp: shopify puts up a full screen "leave the store?" warning for links to sites outside its own list,
// and wa.me is not on it (stores can not add to the list). our own whatsapp links open straight in a new tab.
// shopify's check runs last and stands down when the tap was already handled, so every other outside link keeps it.
document.addEventListener('click', function (e) {
  if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  var a = e.target.closest && e.target.closest('a[href^="https://wa.me/"]');
  if (!a) return;
  e.preventDefault();
  window.open(a.href, '_blank', 'noopener');
});
